/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DnsModule
 */

import { AviPermissionResource } from 'generated-types';
import { DnsPolicy } from 'object-types';
import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { DNS_POLICY_ITEM_TOKEN } from '../dns.tokens';

/**
 * Collection for Dns Policy.
 * @author Abhinesh Gour
 */
export class DnsPolicyCollection extends Collection {
    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'dnspolicy',
            objectType: DnsPolicy,
            permissionName: AviPermissionResource.PERMISSION_DNSPOLICY,
            windowElement: 'lazy-load',
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_(DNS_POLICY_ITEM_TOKEN);
    }
}

DnsPolicyCollection.ajsDependencies = [
    DNS_POLICY_ITEM_TOKEN,
];
